export default {
  free_menu_items: 'Gratis låst op',
  discount_badge: '{{value}} rabat',
  available_at_badge: 'Tilgængelig {{schedule}}',
  restricted_tooltip: 'Tilgængelig {{schedule}} — ændr afhentningstidspunkt ovenfor for at bestille.',
};
